import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Ympyrä',
    polygon: 'Monikulmio',
    zip: 'Postinumero',
  },
  fields: {
    name: {
      label: 'Nimi',
    },
    color: {
      label: 'Väri',
    },
    min_threshold: {
      label: 'Vähimmäistilaussumma',
    },
    max_threshold: {
      label: 'Enimmäistilaussumma',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Toimitusmaksu',
      },
      [DeliveryMode.External]: {
        label: 'Ravintolan maksama maksu',
      },
    },
    zip_codes: {
      label: 'Postinumerot (kukin omalle rivilleen)',
    },
  },
  labels: {
    hidden: '(piilotettu)',
  },
  buttons: {
    save: 'Tallenna',
    cancel_changes: 'Peruuta muutokset',
    add_max_order_amount: 'Lisää enimmäistilaussumma',
  },
  modals: {
    delete_confirmation: {
      title: 'Haluatko varmasti poistaa kohteen {{name}}',
    },
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen kohteelle {{name}} epäonnistui',
    delivery_zone_got_updated: 'Muutokset kohteelle {{name}} tallennettu onnistuneesti',
    failed_to_delete_delivery_zone: 'Kohteen {{name}} poistaminen epäonnistui',
    delivery_zone_got_deleted: 'Kohde {{name}} poistettu onnistuneesti',
  },
};
